/**
 * Resolves the HTTP origin used for ``/v2/chat/*`` (threads + stream) in Vite apps.
 * When ``viteApiUrl`` is empty or the local platform API (:8000), requests must use the
 * current browser origin so the dev proxy forwards ``/v2/chat`` to api-agent. Deployed
 * and remote-API dev use ``viteApiUrl`` as the API host (same as axios).
 */
export function resolveAdvisorV2HttpBaseUrl(viteApiUrl: string | undefined): string {
  const raw = viteApiUrl ?? '';
  const apiBase = raw.replace(/\/$/, '');
  const useViteOrigin = !apiBase || apiBase === 'http://localhost:8000' || apiBase === 'http://127.0.0.1:8000';
  if (useViteOrigin && typeof globalThis !== 'undefined' && 'location' in globalThis) {
    const loc = (globalThis as typeof globalThis & { location?: { origin?: string } }).location;
    if (loc?.origin) {
      return loc.origin;
    }
  }
  return apiBase;
}
